export default __webpack_public_path__ + "static/media/sign2.2d5053a9.png";